import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { LandscapeCard, } from '../../components';

import css from './LandscapesGrid.module.css';

const LandscapesGrid = props => {

  const {
    landscapes,
  } = props;

  if (!landscapes?.length) return null;

  return (
    <div className={classNames(css.root)}>
      {landscapes.map(l => (
        <div className={css.landscapeCardHolder} key={l.blockId}>
          <LandscapeCard
            className={css.landscapeCard}
            key={l.blockId}
            landscape={l}
            isGrid
          />
        </div>
      ))}

    </div>
  );
};

export default LandscapesGrid;
